<template>
  <div class="order-container">
    <div class="search-bar">
      <label>用户名称：</label>
      <input type="text" v-model="searchName" placeholder="用户名称" />
      <label>就餐开始日期：</label>
      <input type="date" v-model="startDate" />
      <label>就餐结束日期：</label>
      <input type="date" v-model="endDate" />
      <button class="search-button" @click="fetchOrders">搜索</button>
      <button class="export-button" @click="exportOrders">导出</button>
    </div>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>用户</th>
          <th>类型</th>
          <th>价格</th>
          <th>核销优惠价格</th>
          <th>就餐日期</th>
          <th>状态</th>
          <th>下单时间</th>
          <th>是否就餐</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in filteredOrders" :key="order.id">
          <td>{{ order.id }}</td>
          <td>{{ order.name }}</td>
          <td :class="{'type-breakfast': order.leixing === '早餐', 'type-lunch': order.leixing === '午餐', 'type-dinner': order.leixing === '晚餐'}">{{ order.leixing }}</td>
          <td>{{ order.money }}</td>
          <td>{{ order.youhui }}</td>
          <td>{{ order.jiucanTime.split(' ')[0] }}</td>
          <td>
            <span class="status-dot" :class="{'status-active': order.isHexiao === 1, 'status-cancelled': order.isHexiao === 0}"></span>
            {{ order.isHexiao === 1 ? '已核销' : '待核销' }}
          </td>
          <td>{{ order.xiadanTime }}</td>
          <td>{{ order.ifJiucan }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mealDate: '',
      searchName: '',
      startDate: '',
      endDate: '',
      orders: [],
      filteredOrders: []
    };
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await this.$axios.get('/api/show_admin_dingdan');
        const data = response.data;
        if (data.code === 0) {
          this.orders = data.data.filter(order => order.isHexiao === 1); // 过滤已核销的订单
          this.filteredOrders = this.orders; // 初始化显示所有订单
        } else {
          console.error('Failed to fetch orders:', data.message);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    },
    filterOrders() {
      this.filteredOrders = this.orders.filter(order => {
        const orderDate = new Date(order.jiucanTime.split(' ')[0]);
        const startDate = this.startDate ? new Date(this.startDate) : null;
        const endDate = this.endDate ? new Date(this.endDate) : null;
        const matchesDate = (!startDate || orderDate >= startDate) && (!endDate || orderDate <= endDate);
        const matchesName = this.searchName ? order.name.toLowerCase().includes(this.searchName.toLowerCase()) : true;
        return matchesDate && matchesName;
      });
    },
    exportOrders() {
      // 定义列名
      const headers = ['ID', '用户', '类型', '价格', '核销优惠价格', '就餐日期', '状态', '下单时间'];
      // 将filteredOrders中的数据转换为CSV格式
      const rows = this.filteredOrders.map(order => [
        order.id,
        order.name,
        order.leixing,
        order.money,
        order.youhui,
        order.jiucanTime.split(' ')[0],
        order.isHexiao === 1 ? '已核销' : '待核销',
        order.xiadanTime
      ]);
      // 将列名和数据组合成CSV内容
      const csvContent = [headers, ...rows].map(row => row.join(',')).join('\n');
      // 创建一个Blob对象，并设置类型为text/csv
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      // 创建一个下载链接
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'orders.csv';
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  },
  watch: {
    mealDate: 'filterOrders',
    searchName: 'filterOrders',
    startDate: 'filterOrders',
    endDate: 'filterOrders'
  },
  mounted() {
    this.fetchOrders();
  }
};
</script>

<style scoped>
.order-container {
  padding: 20px;
  background-color: #f5f5f5;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
}

.search-bar input,
.search-bar button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.search-button {
  background-color: #007bff;
  color: white;
}

.export-button {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.type-breakfast {
  color: green;
}

.type-lunch {
  color: blue;
}

.type-dinner {
  color: orange;
}

.status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.status-active {
  background-color: red;
}

.status-cancelled {
  background-color: green;
}
</style>